// utils/analytics.ts
export const initGA = async () => {
    const ReactGA = await import("react-ga4");
    const { GA4_MEASUREMENT_ID } = await import("../constants/schemas");
  
    ReactGA.default.initialize(GA4_MEASUREMENT_ID || "", {
      gaOptions: {
        debug_mode: process.env.NODE_ENV !== "production",
      },
      gtagOptions: {
        debug_mode: process.env.NODE_ENV !== "production",
      },
    });
  };
  